import { Icon } from "@chakra-ui/react";
import { FaCommentDots } from "react-icons/fa";
import { AssistantPanelTrigger } from "../../../agent/AssistantPanelTrigger";
import { Organizations } from "./Companies";
import { Contracts } from "./Contracts";
import { MyAccount } from "./MyAccount";
import { Notifications } from "./Notifications";
import { Projects } from "./Projects";
import { Sourcing } from "./Sourcing";

export const LgNavbar = () => {
  return (
    <>
      <Projects />
      <Sourcing />
      <Contracts />
      <Organizations />
      <AssistantPanelTrigger colorScheme="teal" icon={<Icon as={FaCommentDots} w="15px" h="15px" />} />
      <Notifications />
      <MyAccount />
    </>
  );
};
